import { FondsPropresService } from "./../../services/fonds-propres.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { TypeFinancement } from "./../../models/TypeFinancement";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { MatSort } from "@angular/material/sort";
import { Component, OnInit, ViewChild } from "@angular/core";

@Component({
  selector: "app-type-financement",
  templateUrl: "./type-financement.component.html",
  styleUrls: ["./type-financement.component.scss"],
})
export class TypeFinancementComponent implements OnInit {
  @ViewChild(MatPaginator, { static: false })
  paginator: MatPaginator;
  @ViewChild(MatSort, { static: false })
  sort: MatSort;
  dataSource: MatTableDataSource<TypeFinancement>;
  isLoadingResults = true;

  displayedColumns = [
    "id",
    "codeTypeFinancement",
    "libelleTypeFinancement",
    "isActive",
    "actions",
  ];
  data: TypeFinancement[] = [];

  constructor(
    private shared: FondsPropresService,
    private modalService: NgbModal
  ) {}

  ngOnInit() {
    this.getTypeFinancements();
  }

  getTypeFinancements() {
    this.shared.getTypeFinancements().subscribe(
      (data) => {
        this.data = data;
      },
      (error) => {
        console.log(error);
        this.isLoadingResults = false;
      },
      () => {
        if (this.data == null) {
          this.data = [];
        }

        this.dataSource = new MatTableDataSource(this.data);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.isLoadingResults = false;
      }
    );
  }

  //View row in modal popup

  /*ViewImportPortefeuilleDeatil(row)
  {
    const modalRef = this.modalService.open(ViewItemDetailComponent,
      {
        centered: true, 
        backdropClass: 'light-blue-backdrop',
        backdrop: 'static',
        scrollable: true,
        windowClass: 'my-modal-class'
      });
    modalRef.componentInstance.portefeuilleDetail = row;
    modalRef.componentInstance.importPortefeuilleId = this.importPortefeuilleId;
    
    modalRef.result.then((result) => {
      console.log("result", result);
         // on close
         //this.getImportPortefeuilleDetails(this.importPortefeuilleId);
      }, 
      (reason) => {
        console.log("reason", reason);
        // on dismiss
      });
      
  }
  */
}
